import qualityLevel from '@/components/dashboard/main/qualityLevel/index.vue';
import successfulReports from '@/components/dashboard/main/successfulReports/index.vue';
import amountErrors from '@/components/dashboard/main/amountErrors/index.vue';
import averageErrors from '@/components/dashboard/main/averageErrors/index.vue';

import { ROLE_SYSTEM_ADMIN } from '@/utils/const';

import Api from '@/utils/api';

export default {
  components: {
    qualityLevel,
    successfulReports,
    amountErrors,
    averageErrors,
  },
  data () {
    return {
      managerList: [],
      sourceLang: [],
      targetLang: [],

      roleAdmin: ROLE_SYSTEM_ADMIN,
    };
  },
  created () {
    this.getLangList();
  },
  methods: {

    /**
         * Method for getting lang list
         */
    getLangList () {
      Api.getLanguage()
        .then((data) => {
          Object.assign(this.sourceLang, data.data);
          Object.assign(this.targetLang, data.data);

          this.sourceLang.unshift({
            ID: '',
            LanguageName: 'All',
          });

          this.targetLang.unshift({
            ID: '',
            LanguageName: 'All',
          });

          if (this.$store.getters.userRole === this.roleAdmin) {
            this.getManagerList();
          }
        });
    },

    /**
         * Method for getting lang list
         */
    getManagerList () {
      Api.user
        .getManagers()
        .then((data) => {
          if (data.data.Status) {
            this.managerList = data.data.Data;
          }
        });
    },
  },
};
